import { Component, OnInit } from '@angular/core';
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {DialogModel} from "@shared/models/dialog.model";
import {QueryProvider} from "@shared/queries/query-provider";
import {FormControl, Validators} from "@angular/forms";

@Component({
    standalone: false,
    selector: 'particle-add-associate-enterprise-entity-dialog',
  templateUrl: './add-associate-enterprise-entity-dialog.component.html',
  styleUrls: ['./add-associate-enterprise-entity-dialog.component.scss']
})
export class AddAssociateEnterpriseEntityDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  displayProperty = 'displayText';
  queryKey = 'AssociateEnterpriseRTPs';
  arguments = {};
  dynamicFormControl = new FormControl('', Validators.required);
  executionId: string;
  selectedEntityId: any;
  constructor() { }

  ngOnInit() {
    this.arguments['RTP_Id']=this.data.input['rtpId'];
  }
  onOkClicked(): boolean {
    this.data.input['selectedRTPEntity']=this.selectedEntityId;
    return true;
  }
  onSelectionChange (event) {
    this.selectedEntityId = event.value;
  }
}
